{
  "common": {
    "back": "Atrás",
    "cancel": "Cancelar",
    "save": "Guardar",
    "update": "Actualizar",
    "retry": "Reintentar",
    "error": "Error",
    "ok": "OK",
    "loading": "Cargando...",
    "delete": "Eliminar",
    "show": "Mostrar",
    "hide": "Ocultar",
    "view": "Ver",
    "email": "Correo electrónico",
    "logout": "Cerrar sesión",
    "subscribe": "Suscribirse",
    "upgrade": "Mejorar plan",
    "manage": "Administrar",
    "continue": "Continuar",
    "processing": "Procesando...",
    "dismiss": "Cerrar",
    "close": "Cerrar",
    "completed": "Completado",
    "remove": "Eliminar"
  },
  "auth": {
    "login": {
      "appName": "Fluencia",
      "subtitle": "Domina tu pronunciación en inglés",
      "emailLabel": "Correo electrónico",
      "emailAccessibility": "Dirección de correo electrónico",
      "passwordLabel": "Contraseña",
      "passwordAccessibility": "Contraseña",
      "forgotPasswordButton": "¿Olvidaste tu contraseña?",
      "signInButton": "Iniciar sesión",
      "dontHaveAccount": "¿No tienes una cuenta?",
      "signUpLink": "Crear cuenta",
      "signUpAccessibility": "Crear cuenta",
      "validationError": "Ingresa tu correo electrónico y contraseña",
      "loginFailedTitle": "Error al iniciar sesión"
    },
    "signup": {
      "title": "Crear cuenta",
      "subtitle": "Únete a Fluencia y empieza a aprender",
      "fullNameLabel": "Nombre completo",
      "fullNamePlaceholder": "Juan Pérez",
      "fullNameError": "El nombre debe tener al menos 2 caracteres",
      "emailLabel": "Correo electrónico",
      "emailError": "Ingresa un correo electrónico válido",
      "passwordLabel": "Contraseña",
      "passwordError": "La contraseña debe tener al menos 8 caracteres",
      "confirmPasswordLabel": "Confirmar contraseña",
      "confirmPasswordError": "Las contraseñas no coinciden",
      "termsCheckboxUnchecked": "Desmarcar acuerdo de términos",
      "termsCheckboxChecked": "Aceptar términos y política de privacidad",
      "termsAgreement": "Acepto los",
      "termsOfService": "Términos de servicio",
      "privacyPolicy": "Política de privacidad",
      "createAccountButton": "Crear cuenta",
      "alreadyHaveAccount": "¿Ya tienes una cuenta?",
      "loginLink": "Iniciar sesión",
      "loginAccessibility": "Iniciar sesión",
      "termsRequiredTitle": "Términos requeridos",
      "termsRequiredMessage": "Acepta los términos y condiciones para continuar",
      "registrationFailedTitle": "Error al crear la cuenta",
      "confirmTitle": "Confirma tu correo",
      "confirmSentTo": "Enviamos un código de confirmación a:",
      "codeLabel": "Código de confirmación",
      "codeAccessibility": "Código de confirmación",
      "codeError": "Ingresa el código de 6 dígitos del correo",
      "verifyCodeButton": "Verificar código",
      "resendButton": "Reenviar código",
      "resendCountdown": "Reenviar código en {{seconds}} s",
      "resendAccessibility": "Reenviar código",
      "confirmExpiry": "También puedes tocar el enlace del correo en lugar de escribir el código.",
      "confirmTip": "Consejo: Revisa tu carpeta de spam si no ves el correo",
      "backToLogin": "Volver a iniciar sesión",
      "fullNameAccessibility": "Nombre completo",
      "emailAccessibility": "Correo electrónico",
      "passwordAccessibility": "Contraseña",
      "confirmPasswordAccessibility": "Confirmar contraseña"
    },
    "forgotPassword": {
      "title": "Restablecer contraseña",
      "subtitle": "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
      "emailLabel": "Correo electrónico",
      "emailError": "Ingresa un correo electrónico válido",
      "sendResetLink": "Enviar enlace",
      "rememberPassword": "¿Recuerdas tu contraseña?",
      "loginLink": "Iniciar sesión",
      "loginAccessibility": "Iniciar sesión",
      "successTitle": "Revisa tu correo",
      "successSentTo": "Enviamos un código de restablecimiento a:",
      "successExpiry": "También puedes tocar el enlace del correo en lugar de escribir el código.",
      "successTip": "Consejo: Revisa tu carpeta de spam si no ves el correo",
      "successBackButton": "Volver a iniciar sesión",
      "successRetryText": "¿No recibiste el correo?",
      "successRetryLink": "Intentar de nuevo",
      "successRetryAccessibility": "Intentar de nuevo",
      "emailAccessibility": "Correo electrónico",
      "codeLabel": "Código de restablecimiento",
      "codeAccessibility": "Código de restablecimiento",
      "codeError": "Ingresa el código de 6 dígitos del correo",
      "verifyCodeButton": "Verificar código",
      "resendButton": "Reenviar código",
      "resendCountdown": "Reenviar código en {{seconds}} s",
      "resendAccessibility": "Reenviar código"
    },
    "resetPassword": {
      "title": "Nueva contraseña",
      "subtitle": "Tu nueva contraseña debe tener al menos 8 caracteres",
      "newPasswordLabel": "Nueva contraseña",
      "newPasswordError": "La contraseña debe tener al menos 8 caracteres",
      "confirmPasswordLabel": "Confirmar nueva contraseña",
      "confirmPasswordError": "Las contraseñas no coinciden",
      "updateButton": "Actualizar contraseña",
      "backToLogin": "Volver a iniciar sesión",
      "backToLoginAccessibility": "Volver a iniciar sesión",
      "successTitle": "Contraseña actualizada",
      "successMessage": "Tu contraseña se actualizó correctamente. Ya puedes iniciar sesión con tu nueva contraseña.",
      "passwordAccessibility": "Nueva contraseña",
      "confirmPasswordAccessibility": "Confirmar nueva contraseña"
    }
  },
  "chat": {
    "header": {
      "title": "Fluencia Chat",
      "subtitle": "Tutor IA listo",
      "streakDay_one": "{{count}} día",
      "streakDay_other": "{{count}} días"
    },
    "topics": {
      "readyTitle": "¿Listo para practicar?",
      "readyBody": "Envía un mensaje de texto o voz y recibe comentarios sobre tu gramática, pronunciación y fluidez.",
      "tipTitle": "Consejo",
      "tipBody": "Prueba el micrófono para recibir comentarios sobre tu pronunciación. Habla con naturalidad — ¡los errores son parte del aprendizaje!",
      "dayLabel": "Habla sobre tu día",
      "dayPrompt": "\"Hoy yo...\"",
      "weekendLabel": "Describe tu fin de semana",
      "weekendPrompt": "\"El fin de semana pasado...\"",
      "hobbyLabel": "Tu pasatiempo favorito",
      "hobbyPrompt": "\"Me gusta mucho...\"",
      "freeLabel": "Conversación libre",
      "freePrompt": "¡Di lo que quieras!"
    },
    "input": {
      "placeholder": "Escribe un mensaje...",
      "voiceButtonLabel": "Grabar mensaje de voz",
      "sendButtonLabel": "Enviar mensaje",
      "inputLabel": "Campo de mensaje"
    },
    "voice": {
      "preparingMicrophone": "Preparando micrófono...",
      "microphonePermission": "Permite el acceso al micrófono si se solicita",
      "recording": "Grabando",
      "processing": "Procesando",
      "listeningPlaceholder": "Escuchando... habla con naturalidad",
      "silenceWarning": "Sigue hablando o la grabación terminará...",
      "recordingWillStop": "La grabación se detendrá a los 30 segundos",
      "cancelButton": "Cancelar grabación",
      "stopButton": "Detener grabación",
      "retryButton": "Reintentar grabación",
      "analyzeHint": "Toca el botón verde para detener y analizar",
      "analyzingHint": "Analizando tu pronunciación...",
      "recordingFailedError": "Error en la grabación",
      "noSpeechDetectedError": "No se detectó voz. Inténtalo de nuevo.",
      "connectionError": "Revisa tu conexión e inténtalo de nuevo",
      "serviceError": "Servicio no disponible. Inténtalo más tarde",
      "connectionLostWarning": "Se perdió la conexión. Tu mensaje se enviará al reconectar."
    },
    "pronunciation": {
      "hint": "Di esto en voz alta",
      "referenceLabel": "Practica diciendo: {{text}}",
      "freeLabel": "Habla libremente para practicar la pronunciación",
      "dismiss": "Cerrar indicación de pronunciación"
    },
    "tts": {
      "connectionError": "Revisa tu conexión",
      "serviceError": "Inténtalo más tarde",
      "rateLimited": "Inténtalo más tarde",
      "playbackError": "Error de reproducción"
    },
    "consent": {
      "title": "Funciones con inteligencia artificial",
      "subtitle": "Fluencia usa IA para ayudarte a aprender inglés",
      "explanation": "Para darte comentarios personalizados sobre tu pronunciación y gramática, compartimos algunos datos con los siguientes servicios de IA:",
      "purposeLabel": "Propósito: ",
      "dataSharedLabel": "Datos compartidos: ",
      "providers": {
        "geminiName": "Google Gemini",
        "geminiPurpose": "Análisis de conversación y retroalimentación gramatical",
        "geminiDataShared": "Texto de tus mensajes (no grabaciones de audio)",
        "openaiName": "OpenAI",
        "openaiPurpose": "Análisis de conversación y retroalimentación gramatical",
        "openaiDataShared": "Texto de tus mensajes (no grabaciones de audio)",
        "anthropicName": "Anthropic",
        "anthropicPurpose": "Generación de escenarios para juegos de rol",
        "anthropicDataShared": "Texto de tus mensajes (no grabaciones de audio)",
        "azureName": "Microsoft Azure Speech Services",
        "azurePurpose": "Reconocimiento de voz y evaluación de pronunciación",
        "azureDataShared": "Grabaciones de audio durante los ejercicios de pronunciación"
      },
      "importantInfoTitle": "Información importante",
      "voiceRecordingNote": "Tus grabaciones de voz se procesan en tiempo real y no se almacenan permanentemente",
      "textAnalysisNote": "El análisis de texto ayuda a identificar mejoras gramaticales",
      "withdrawConsentNote": "Puedes revocar tu consentimiento en cualquier momento desde Configuración",
      "privacyPolicyLink": "Lee nuestra Política de privacidad completa",
      "acceptButton": "Entiendo y acepto",
      "declineButton": "Ahora no",
      "disclaimerText": "Sin consentimiento, las funciones con IA como el análisis de conversación y los comentarios de pronunciación no estarán disponibles."
    },
    "messages": {
      "sendingStatus": "Enviando...",
      "retryTooltip": "Reintentar envío de mensaje",
      "retryText": "Toca para reintentar",
      "analyzing": "Analizando...",
      "analysisInProgress": "Análisis en curso",
      "analysisFailed": "El análisis ha fallado",
      "analysisUnavailable": "⚠️ Análisis no disponible",
      "tapToRetryAnalysis": "— Toca para reintentar",
      "retryAnalysis": "Reintentar análisis",
      "retryAnalysisHint": "Toca dos veces para reintentar el análisis",
      "listenToMessage": "Escuchar mensaje",
      "stopListening": "Dejar de escuchar",
      "narration": "Narración",
      "cue": "Tu turno"
    },
    "analysis": {
      "pronunciationSection": "PRONUNCIACIÓN",
      "accuracyLabel": "Precisión",
      "fluencyLabel": "Fluidez",
      "prosodyLabel": "Prosodia",
      "grammarTipsSection": "CONSEJOS DE GRAMÁTICA",
      "soundMoreNativeSection": "SUENA MÁS NATURAL",
      "studyThisSection": "ESTUDIA ESTO",
      "lessonLinkLabel": "Estudiar: ",
      "reportButton": "Reportar",
      "reportAnalysisLabel": "Reportar análisis",
      "tip_one": "{{count}} consejo",
      "tip_other": "{{count}} consejos",
      "practiceThis": "Practicar esto"
    },
    "feedback": {
      "viewLabel": "Ver comentarios",
      "view": "Ver",
      "expandLabel": "Expandir comentarios",
      "collapseLabel": "Contraer comentarios",
      "collapseHint": "Toca para contraer ↑"
    },
    "quickPractice": {
      "title": "Práctica rápida",
      "loading": "Generando práctica...",
      "explanation": "Explicación",
      "examples": "Ejemplos",
      "exercises": "Ejercicios"
    },
    "report": {
      "title": "Reportar contenido de IA",
      "question": "¿Reportar este contenido generado por IA como inapropiado o incorrecto?",
      "duplicateMessage": "Ya reportaste este contenido. Lo revisaremos.",
      "successMessage": "Gracias por tus comentarios. Revisaremos esta respuesta de IA.",
      "cancelButton": "Cancelar",
      "reportButton": "Reportar"
    },
    "connection": {
      "reconnecting": "Reconectando...",
      "reconnectingSlow": "Está tardando más de lo habitual...",
      "failed": "Conexión perdida",
      "tapToReconnect": "Toca para reconectar",
      "sessionExpired": "Sesión expirada",
      "signInAgain": "Iniciar sesión de nuevo",
      "queued": "Mensaje en cola — se enviará al conectar"
    }
  },
  "conversations": {
    "title": "Conversaciones",
    "newConversation": "Nueva conversación",
    "empty": "Aún no tienes conversaciones. ¡Empieza una nueva!",
    "untitled": "Conversación sin título",
    "messageCount": "{{count}} mensajes",
    "justNow": "ahora",
    "minutesAgo": "hace {{count}} min",
    "hoursAgo": "hace {{count}} h",
    "daysAgo": "hace {{count}} d"
  },
  "hub": {
    "title": "Empieza a practicar",
    "subtitle": "Elige cómo quieres practicar hoy",
    "historyButton": "Historial de conversaciones",
    "switchCourse": "Cambiar curso",
    "pronunciation": {
      "title": "Pronunciación",
      "subtitle": "Practica a hablar con claridad"
    },
    "conversation": {
      "title": "Conversación",
      "subtitle": "Habla libremente de cualquier tema"
    },
    "grammar": {
      "title": "Gramática",
      "subtitle": "Enfócate en las reglas gramaticales"
    },
    "roleplay": {
      "title": "Simulaciones",
      "subtitle": "Practica situaciones de la vida real"
    },
    "quickQuestion": {
      "title": "Pregunta rápida",
      "subtitle": "Obtén una respuesta rápida"
    }
  },
  "roleplay": {
    "list": {
      "title": "Simulaciones",
      "sectionYours": "Tus juegos de rol",
      "createCustom": "Crear juego de rol personalizado",
      "slotsFull": "{{cap}}/{{cap}} espacios usados",
      "slotLabel": "{{title}} — {{scenario}}",
      "templateLabel": "{{title}}",
      "loadErrorRetry": "Reintentar"
    },
    "templates": {
      "preview": {
        "title": "Vista previa",
        "sectionVocabulary": "Vocabulario",
        "sectionPhrases": "Frases clave",
        "startButton": "Comenzar este juego de rol",
        "statusNew": "Nueva",
        "statusLearning": "En curso",
        "statusMastered": "Dominada"
      }
    },
    "detail": {
      "title": "Simulación",
      "fieldScenario": "Escenario",
      "fieldDetails": "Detalles",
      "fieldUserRole": "Tu papel",
      "fieldAiRole": "Papel de la IA",
      "fieldFirstSpeaker": "Quién habla primero",
      "firstSpeakerUser": "Tú",
      "firstSpeakerAi": "La IA",
      "openButton": "Abrir conversación",
      "restartButton": "Reiniciar",
      "removeButton": "Eliminar",
      "restartConfirmTitle": "¿Reiniciar esta simulación?",
      "restartConfirmBody": "Se borrará la conversación anterior y comenzará una nueva con la misma configuración.",
      "restartConfirmButton": "Reiniciar",
      "removeConfirmTitle": "¿Eliminar esta simulación?",
      "removeConfirmBody": "Se eliminarán la configuración y su conversación. Esto no se puede deshacer.",
      "removeConfirmButton": "Eliminar",
      "cancelButton": "Cancelar"
    },
    "collections": {
      "sectionTitle": "Colecciones",
      "progress": "{{completed}}/{{total}} hechos",
      "cardLabel": "{{title}}, {{completed}} de {{total}} hechos",
      "searchPlaceholder": "Buscar juegos de rol",
      "searchClear": "Borrar búsqueda",
      "searchEmpty": "Sin coincidencias. Probá otra palabra.",
      "emptyHint": "Aún no hay colecciones disponibles.",
      "difficultyLabel": "Niv. {{level}}",
      "filterDifficultyLabel": "Filtrar por nivel {{level}}",
      "filterCompleted": "Completados",
      "filterUncompleted": "Sin empezar"
    }
  },
  "practice": {
    "tip": "Consejo: ¡Practica 15 minutos al día para mejores resultados!",
    "continueLesson": "Continuar",
    "resumeLesson": "Reanudar",
    "nextLesson": "Siguiente",
    "loadingPath": "Cargando lecciones...",
    "pathError": "No se pudieron cargar las lecciones.",
    "noLessonsForLevel": "Aún no hay lecciones para {{level}}",
    "updateLessons": "Actualizar lecciones",
    "selectLesson": "Selecciona una lección para empezar",
    "recommended": {
      "title": "Recomendado para ti",
      "subtitle": "Según los errores que cometes con más frecuencia",
      "itemLabel": "Estudiar: ",
      "focusLabel": "Practicar en conversación: ",
      "mistakeCount_one": "{{count}} error",
      "mistakeCount_other": "{{count}} errores",
      "errorTypes": {
        "verb_tense": "Tiempos verbales",
        "past_tense": "Pasado simple",
        "present_simple": "Presente simple",
        "present_continuous": "Presente continuo",
        "present_perfect": "Presente perfecto",
        "future_forms": "Formas de futuro",
        "passive_voice": "Voz pasiva",
        "conditionals": "Condicionales",
        "subjunctive": "Subjuntivo",
        "modal_verbs": "Verbos modales",
        "auxiliary_verbs": "Verbos auxiliares",
        "gerund_vs_infinitive": "Gerundio o infinitivo",
        "reported_speech": "Discurso indirecto",
        "verb_complementation": "Estructuras verbales",
        "question_tags": "Coletillas interrogativas",
        "phrasal_verbs": "Verbos con partícula",
        "question_formation": "Formación de preguntas",
        "negation": "Negación",
        "there_is_are": "There is / there are",
        "subject_verb_agreement": "Concordancia sujeto-verbo",
        "modal_nuance": "Matices de los modales",
        "articles": "Artículos",
        "singular_plural": "Singular y plural",
        "countable_uncountable": "Contables e incontables",
        "quantifiers": "Cuantificadores",
        "possessives": "Posesivos",
        "demonstratives": "Demostrativos",
        "pronouns": "Pronombres",
        "subject_pronoun_omission": "Pronombres de sujeto",
        "reflexive_pronouns": "Pronombres reflexivos",
        "gender_confusion": "He, she e it",
        "adjective_order": "Orden de los adjetivos",
        "adjective_adverb": "Adjetivos y adverbios",
        "adverb_position": "Posición del adverbio",
        "comparatives": "Comparativos",
        "intensifiers": "Intensificadores",
        "degree_too_very_much": "Too, very y much",
        "word_order": "Orden de las palabras",
        "sentence_structure": "Estructura de la oración",
        "relative_clauses": "Oraciones de relativo",
        "conjunctions": "Conjunciones",
        "prepositions": "Preposiciones",
        "duration_since_for": "Since y for",
        "ellipsis": "Elipsis",
        "inversion": "Inversión",
        "cleft_sentences": "Oraciones escindidas",
        "fronting_emphasis": "Énfasis y anteposición",
        "nominalization": "Nominalización",
        "vocabulary": "Vocabulario",
        "word_choice": "Elección de palabras",
        "false_friends": "Falsos amigos",
        "collocations": "Combinaciones de palabras",
        "spanish_transfer": "Traducción literal",
        "ser_estar": "El verbo \"be\"",
        "register": "Registro",
        "pragmatics": "Cortesía y tono",
        "discourse_markers": "Conectores del discurso",
        "coherence": "Coherencia",
        "hedging_stance": "Matización",
        "spelling": "Ortografía",
        "punctuation": "Puntuación",
        "capitalization": "Mayúsculas",
        "pronunciation": "Pronunciación",
        "pronunciation_consonants": "Sonidos consonánticos",
        "pronunciation_vowels": "Sonidos vocálicos",
        "pronunciation_stress": "Acentuación",
        "pronunciation_rhythm": "Ritmo",
        "pronunciation_prosody": "Entonación",
        "plural_pronunciation": "Pronunciación del plural",
        "word_stress": "Acentuación",
        "connected_speech": "Habla enlazada",
        "reduced_forms": "Formas reducidas",
        "accent_awareness": "Reconocimiento de acentos",
        "listening_comprehension": "Comprensión auditiva",
        "academic_listening": "Escucha académica",
        "inference": "Inferencia",
        "main_idea": "Idea principal",
        "critical_thinking": "Pensamiento crítico",
        "media_literacy": "Alfabetización mediática",
        "note_taking": "Toma de notas",
        "other": "Otro"
      }
    },
    "categories": {
      "all": "Todas",
      "grammar": "Gramática",
      "vocabulary": "Vocabulario",
      "pronunciation": "Pronunciación",
      "communication": "Comunicación",
      "spanish-challenges": "Desafíos",
      "listening": "Escucha",
      "writing": "Escritura",
      "culture": "Cultura"
    },
    "cefrHints": {
      "a1": "Frases y oraciones básicas",
      "a2": "Expresiones cotidianas y rutinas",
      "b1": "Ideas principales y experiencias personales",
      "b2": "Textos complejos y temas abstractos",
      "c1": "Matices, modismos y fluidez",
      "c2": "Precisión y dominio casi nativo"
    }
  },
  "profile": {
    "header": {},
    "info": {
      "title": "Información del perfil",
      "nameLabel": "Nombre para mostrar",
      "namePlaceholder": "¿Cómo quieres que te llamemos?",
      "nameHint": "Así te llamará la IA en las conversaciones"
    },
    "appearance": {
      "title": "Apariencia",
      "themeLabel": "Tema",
      "light": "Claro",
      "dark": "Oscuro",
      "system": "Sistema"
    },
    "courses": {
      "title": "Mis cursos",
      "list": "Tus cursos",
      "activeCourse": "Activo",
      "addCourse": "Agregar curso",
      "removeCourseTitle": "Eliminar curso",
      "removeCourseMessage": "¿Seguro que quieres eliminar este curso? Tu progreso se mantendrá.",
      "courseLimitExceeded": "Puedes tener hasta {{max}} cursos. Elimina uno para agregar otro.",
      "languageSettings": "Configuración de idioma"
    },
    "language": {
      "title": "Idioma",
      "appLanguage": "Idioma de la app"
    },
    "audioSpeech": {
      "title": "Audio y voz",
      "autoplayTitle": "Reproducción automática",
      "autoplayDescription": "Leer las respuestas de la IA en voz alta automáticamente",
      "micTest": "Prueba de micrófono",
      "micTestWebUnavailable": "Por ahora, solo está disponible en las apps de iOS y Android"
    },
    "learning": {
      "languageSettings": "Configuración de idioma",
      "autoplayTitle": "Reproducción automática",
      "ttsVoiceTitle": "Calidad de voz",
      "ttsVoiceDevice": "Dispositivo",
      "ttsVoiceAzure": "Neural",
      "ttsVoiceSelectLabel": "Voz",
      "debugContextSnapshotsTitle": "Capturas de contexto (depuración)",
      "debugContextSnapshotsDescription": "Adjunta el contexto exacto de la IA a los metadatos de cada respuesta, para depuración",
      "lessonFeedbackTitle": "Retroalimentación de lecciones",
      "lessonFeedbackDescription": "Mostrar botones de retroalimentación en el contenido de lecciones"
    },
    "subscription": {
      "title": "Suscripción",
      "pro": "Fluencia Pro",
      "freeTrial": "Prueba gratuita",
      "freePlan": "Plan gratuito",
      "daysRemaining_one": "{{count}} día restante",
      "daysRemaining_other": "{{count}} días restantes",
      "upgradeMessage": "Mejora tu plan para acceso ilimitado",
      "manageAccessibility": "Administrar suscripción",
      "upgradeAccessibility": "Mejorar suscripción"
    },
    "security": {
      "title": "Seguridad",
      "changePassword": "Cambiar contraseña",
      "changePasswordAccessibility": "Cambiar contraseña",
      "newPasswordLabel": "Nueva contraseña",
      "newPasswordAccessibility": "Nueva contraseña",
      "newPasswordPlaceholder": "Ingresa nueva contraseña",
      "confirmPasswordLabel": "Confirmar contraseña",
      "confirmPasswordAccessibility": "Confirmar nueva contraseña",
      "confirmPasswordPlaceholder": "Confirma nueva contraseña",
      "passwordMinLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordsMismatch": "Las contraseñas no coinciden",
      "passwordUpdated": "Contraseña actualizada correctamente"
    },
    "aiConsent": {
      "description": "Fluencia usa servicios de IA externos para ofrecer comentarios de pronunciación y análisis gramatical.",
      "granted": "Consentimiento otorgado",
      "notGranted": "Consentimiento no otorgado",
      "dataSharedWith": "Tus datos pueden compartirse con:",
      "notGrantedDescription": "Las funciones con IA están deshabilitadas. Otorga consentimiento desde el Chat para habilitar los comentarios de pronunciación y gramática.",
      "withdrawButton": "Revocar consentimiento de IA",
      "withdrawTitle": "Revocar consentimiento de IA",
      "withdrawMessage": "¿Estás seguro de que quieres revocar el consentimiento de IA?\n\nLas funciones como comentarios de pronunciación y análisis gramatical se deshabilitarán."
    },
    "support": {
      "title": "Ayuda y soporte",
      "contactSupport": "Contactar soporte",
      "contactSupportAccessibility": "Contactar soporte",
      "privacyPolicy": "Política de privacidad",
      "privacyPolicyAccessibility": "Ver política de privacidad",
      "termsOfService": "Términos de servicio",
      "termsOfServiceAccessibility": "Ver términos de servicio"
    },
    "devTools": {
      "title": "Herramientas de desarrollo",
      "showAccessibility": "Mostrar herramientas de desarrollo",
      "hideAccessibility": "Ocultar herramientas de desarrollo",
      "checkBackendHealth": "Verificar estado del backend",
      "environment": "Entorno:",
      "commitBranch": "Commit / Rama:",
      "errorPrefix": "Error: {{message}}",
      "refreshAllData": "Actualizar todos los datos",
      "refreshAllStarted": "Actualizando todos los datos..."
    },
    "privacyLegal": {
      "title": "Privacidad y legal"
    },
    "account": {
      "sectionTitle": "Cuenta",
      "title": "Cuenta",
      "checkingStatus": "Verificando estado de la cuenta...",
      "couldntLoadStatus": "No se pudo cargar el estado de eliminación de la cuenta.",
      "deletionScheduled": "Eliminación de cuenta programada",
      "deletionMessage": "Tu cuenta se eliminará permanentemente en",
      "day_one": "{{count}} día",
      "day_other": "{{count}} días",
      "scheduledFor": "Programado para: {{date}}",
      "cancelDeletion": "Cancelar eliminación",
      "deleteDescription": "Elimina permanentemente tu cuenta y todos los datos asociados. Tendrás 30 días para cancelar antes de que sea definitivo.",
      "deleteButton": "Eliminar cuenta",
      "deleteConfirmTitle": "Eliminar cuenta",
      "deleteConfirmMessage": "¿Estás seguro de que quieres eliminar tu cuenta?\n\nTus datos se eliminarán permanentemente en 30 días. Puedes cancelar esta solicitud en cualquier momento durante el periodo de gracia.",
      "deletionSuccess": "Eliminación de cuenta programada. Tienes 30 días para cancelar esta solicitud.",
      "cancellationSuccess": "Solicitud de eliminación cancelada. Tu cuenta no se eliminará."
    },
    "logout": {
      "confirmTitle": "Cerrar sesión",
      "confirmMessage": "¿Estás seguro de que quieres cerrar sesión?"
    }
  },
  "tabs": {
    "practice": "Práctica"
  },
  "lessons": {
    "generatingExercises": "Generando ejercicios personalizados...",
    "generatingExercisesSubtext": "Esto puede tardar unos segundos",
    "exerciseGenerationError": "No se pudieron generar los ejercicios. Inténtalo de nuevo más tarde.",
    "aiConsentRequired": "Es necesario activar el uso compartido de datos de IA para generar ejercicios personalizados.",
    "enableAIExercises": "Activar ejercicios con IA",
    "generateExercisesPrompt": "Toca abajo para generar ejercicios adaptados a tu nivel.",
    "generateExercisesButton": "Generar ejercicios",
    "generateNewExercises": "Generar nuevos ejercicios",
    "detail": {
      "exercises": "Ejercicios",
      "completeLesson": "Completar lección",
      "lessonUpdated": "Esta lección se actualizó. Toca para ver la nueva versión.",
      "exerciseNotSupported": "El tipo de ejercicio \"{{type}}\" aún no es compatible.",
      "exerciseSkipped": "No se pudo cargar este ejercicio. Intenta generar nuevos.",
      "showAnswer": "Mostrar respuesta",
      "exercise": "Ejercicio",
      "noContent": "No hay contenido disponible",
      "unableToLoad": "No se pudo cargar esta lección."
    },
    "scoreCard": {
      "excellent": "¡Excelente!",
      "great": "¡Muy bien!",
      "good": "¡Buen esfuerzo!",
      "keepPracticing": "¡Sigue practicando!",
      "newHighScore": "¡Nueva mejor puntuación!",
      "attempt": "Intento n.º {{number}}",
      "best": "Mejor: {{score}}%",
      "nextReview_one": "Próximo repaso en {{count}} día",
      "nextReview_other": "Próximo repaso en {{count}} días",
      "continue": "Continuar",
      "tryAgain": "Intentar de nuevo"
    },
    "due": {
      "title": "Para repasar",
      "sectionOverdue": "Atrasadas",
      "sectionReady": "Listas para repasar",
      "dueToday": "Vence hoy",
      "overdueBy_one": "{{count}} día de atraso",
      "overdueBy_other": "{{count}} días de atraso",
      "lastScore": "Última puntuación: {{score}}%",
      "empty": "¡Todo al día! No hay nada para repasar por ahora.",
      "browse": "Ver lecciones",
      "card": {
        "title": "Para repasar",
        "cta": "Repasa las lecciones que completaste",
        "caughtUp": "Todo al día",
        "count_one": "{{count}} lección para repasar",
        "count_other": "{{count}} lecciones para repasar"
      }
    },
    "cefrLevels": {
      "a1": "Principiante",
      "a2": "Elemental",
      "b1": "Intermedio",
      "b2": "Intermedio alto",
      "c1": "Avanzado",
      "c2": "Dominio"
    },
    "feedback": {
      "button": "Dar retroalimentación",
      "sectionPlaceholder": "¿Qué te pareció esta sección?",
      "lessonPlaceholder": "¿Qué te pareció esta lección?",
      "submit": "Enviar",
      "success": "¡Gracias por tu retroalimentación!",
      "error": "No se pudo enviar. Inténtalo de nuevo."
    }
  },
  "paywall": {
    "successTitle": "¡Bienvenido a Fluencia Pro!",
    "successMessage": "Tu suscripción está activa. ¡Disfruta acceso ilimitado a todas las funciones!",
    "restoreSuccessTitle": "Compras restauradas",
    "restoreSuccessMessage": "Tu suscripción se restauró correctamente.",
    "restoreNoMessage": "No pudimos encontrar compras anteriores para restaurar.",
    "activeTitle": "¡Eres Pro!",
    "activeMessage": "Tienes acceso completo a todas las funciones de Fluencia.",
    "renews": "Se renueva:",
    "manageSubscription": "Administrar suscripción",
    "unlockTitle": "Desbloquea tu fluidez",
    "upgradeToAccess": "Mejora tu plan para acceder",
    "daysLeftInTrial": "{{count}} días de prueba restantes",
    "proBenefitsTitle": "Beneficios Pro",
    "unlimitedPronunciation": "Evaluaciones de pronunciación ilimitadas",
    "aiConversationPractice": "Práctica de conversación con IA",
    "accessAllLessons": "Acceso a todas las lecciones",
    "detailedFeedback": "Comentarios detallados de pronunciación",
    "progressTracking": "Seguimiento de progreso y estadísticas",
    "prioritySupport": "Soporte prioritario",
    "viewSubscriptionOptions": "Ver opciones de suscripción",
    "restorePurchases": "Restaurar compras",
    "paymentCharged": "El pago se cargará a tu",
    "appleId": "Apple ID",
    "googlePlay": "Google Play",
    "paymentMethod": "método de pago",
    "autoRenewDisclaimer": "La suscripción se renueva automáticamente a menos que se cancele al menos 24 horas antes del final del periodo actual.",
    "termsOfService": "Términos de servicio",
    "privacyPolicy": "Política de privacidad"
  },
  "exercises": {
    "hint": "Pista:",
    "errorCorrection": {
      "correctionFor": "Corrección para «{{word}}»:",
      "typeCorrection": "Escribe la corrección...",
      "apply": "Aplicar",
      "removeWord": "Esta palabra sobra — quítala",
      "removeWordShort": "quitar",
      "removeWordA11y": "Marcar {{word}} como una palabra que sobra",
      "wordA11y": "Palabra: {{word}}",
      "wordFlaggedA11y": "Palabra: {{word}}, marcada",
      "checkCorrections": "Revisar correcciones",
      "allCorrect": "¡Todas las correcciones son correctas!",
      "score": "Puntuación: {{score}}%"
    },
    "dialogueCompletion": {
      "selectAnswer": "Elige una respuesta...",
      "typeAnswer": "Escribe tu respuesta...",
      "answerForA11y": "Respuesta para {{speaker}}",
      "blankA11y": "Espacio {{number}} en la línea de {{speaker}}",
      "checkAnswer": "Revisar respuesta",
      "correct": "¡Correcto!",
      "notQuite": "No es correcto",
      "expected": "Se esperaba: «{{answer}}»"
    }
  },
  "soundMap": {
    "title": "Mapa de sonidos",
    "loading": "Cargando tu mapa de sonidos...",
    "loadError": "No se pudo cargar tu mapa de sonidos.",
    "progressLabel": "{{mastered}} de {{total}} sonidos dominados",
    "summary": {
      "mastered_one": "{{count}} dominado",
      "mastered_other": "{{count}} dominados",
      "learning_one": "{{count}} en progreso",
      "learning_other": "{{count}} en progreso",
      "weak_one": "{{count}} débil",
      "weak_other": "{{count}} débiles",
      "untried_one": "{{count}} sin practicar",
      "untried_other": "{{count}} sin practicar"
    },
    "sections": {
      "consonants": "Consonantes",
      "vowels": "Vocales",
      "diphthongs": "Diptongos",
      "tones": "Tonos"
    },
    "states": {
      "mastered": "Dominado",
      "learning": "En progreso",
      "weak": "Débil",
      "untried": "Sin practicar"
    },
    "chip": {
      "scoreValue": "{{score}}%",
      "a11yMastered": "{{symbol}}, dominado, {{score}} por ciento",
      "a11yLearning": "{{symbol}}, en progreso, {{score}} por ciento",
      "a11yWeak": "{{symbol}}, débil, {{score}} por ciento",
      "a11yUntried": "{{symbol}}, sin practicar",
      "a11yUntriedHard": "{{symbol}}, sin practicar, suele ser difícil"
    },
    "detail": {
      "exampleWordsTitle": "Palabras de ejemplo",
      "statsAvgScore": "Puntuación promedio",
      "statsAttempts": "Intentos",
      "statsLastPracticed": "Última práctica",
      "notPracticedYet": "Todavía no has practicado este sonido.",
      "difficultyLabel": "Dificultad esperada",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "Este sonido suele ser difícil para hispanohablantes.",
      "tipsTitle": "Consejos",
      "practiceButton": "Practicar este sonido",
      "closeA11y": "Cerrar detalles del sonido"
    },
    "practiceCard": {
      "title": "Mapa de sonidos",
      "subtitle": "Sigue tu dominio de cada sonido",
      "cta": "Abre el mapa de sonidos"
    },
    "guidanceOnly": {
      "summary": "Los sonidos del inglés que más cuestan a quienes hablan español",
      "body": "Estos son los sonidos de tu inglés. Los marcados son los que suelen costar más a quienes hablan español: toca cualquiera para ver consejos y practicarlo con tu tutor."
    }
  },
  "competenceMap": {
    "title": "Mapa de competencias",
    "loading": "Cargando tu mapa de competencias...",
    "loadError": "No se pudo cargar tu mapa de competencias.",
    "progressLabel": "{{mastered}} de {{total}} competencias dominadas",
    "dueTitle": "Para repasar hoy",
    "bandEmpty": "Todavía no hay contenido de este nivel.",
    "bandCount_one": "{{count}} competencia",
    "bandCount_other": "{{count}} competencias",
    "bandLater_one": "{{count}} más adelante",
    "bandLater_other": "{{count}} más adelante",
    "summary": {
      "mastered_one": "{{count}} dominada",
      "mastered_other": "{{count}} dominadas",
      "learning_one": "{{count}} en progreso",
      "learning_other": "{{count}} en progreso",
      "struggling_one": "{{count}} con dificultades",
      "struggling_other": "{{count}} con dificultades",
      "untried_one": "{{count}} sin ver",
      "untried_other": "{{count}} sin ver",
      "upcoming_one": "{{count}} más adelante",
      "upcoming_other": "{{count}} más adelante"
    },
    "bands": {
      "A1": "A1 · Principiante",
      "A2": "A2 · Elemental",
      "B1": "B1 · Intermedio",
      "B2": "B2 · Intermedio alto",
      "C1": "C1 · Avanzado",
      "C2": "C2 · Dominio",
      "any": "En cualquier nivel"
    },
    "states": {
      "mastered": "Dominada",
      "learning": "En progreso",
      "struggling": "Con dificultades",
      "untried": "Sin ver",
      "upcoming": "Más adelante"
    },
    "chip": {
      "due": "Para repasar",
      "a11y": "{{name}}, {{state}}",
      "a11yWithHard": "{{name}}, {{state}}, suele ser difícil"
    },
    "detail": {
      "examplesTitle": "Ejemplos",
      "exampleCorrect": "✓ {{text}}",
      "exampleIncorrect": "✗ {{text}}",
      "statsProductions": "Usos correctos",
      "statsStruggles": "Errores",
      "statsSessions": "Sesiones",
      "statsLastUsed": "Última vez",
      "statsNextReview": "Próximo repaso",
      "notSeenYet": "Todavía no te hemos visto usar esto.",
      "comesLater": "Esto llega más adelante en tu recorrido.",
      "difficultyLabel": "Dificultad esperada",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "Esto suele ser difícil para hispanohablantes.",
      "tipsTitle": "Consejos",
      "practiceButton": "Practicar esto",
      "closeA11y": "Cerrar detalles de la competencia"
    },
    "practiceCard": {
      "title": "Mapa de competencias",
      "subtitle": "Sigue tu dominio de la gramática",
      "cta": "Abre el mapa de competencias"
    }
  },
  "vocabulary": {
    "title": "Tu vocabulario",
    "hubCard": {
      "title": "Tu vocabulario",
      "subtitle": "Palabras y expresiones que practicas",
      "counts": "{{mastered}} dominadas · {{due}} para repasar"
    },
    "counts": {
      "new": "Nuevas",
      "learning": "Aprendiendo",
      "mastered": "Dominadas"
    },
    "levels": {
      "title": "Tu progreso por nivel",
      "assessedTag": "tu nivel",
      "progress": "{{mastered}} de {{total}} palabras",
      "breakdown": "{{mastered}} dominadas · {{learning}} aprendiendo · {{fresh}} nuevas",
      "due": "{{due}} para repasar",
      "empty": "Todavía no hay palabras de nivel {{level}} en tu progreso. Prueba una simulación para empezar.",
      "note": "Los niveles son una guía aproximada para orientar tu práctica, no una evaluación de tu nivel."
    },
    "due": {
      "title": "Para repasar",
      "empty": "No tienes nada pendiente de repaso. ¡Sigue así!",
      "more": "y {{overflow}} más para repasar"
    },
    "list": {
      "learning": "Aprendiendo",
      "mastered": "Dominadas",
      "empty": "Todavía no hay nada aquí. Prueba una simulación para empezar."
    },
    "error": {
      "retry": "Reintentar"
    }
  },
  "errorBoundary": {
    "title": "Algo salió mal",
    "message": "Lo sentimos, ocurrió algo inesperado. Nuestro equipo fue notificado y estamos trabajando para solucionarlo.",
    "suggestion": "Intenta de nuevo más tarde.",
    "retryButton": "Intentar de nuevo",
    "debugInfo": "Info de depuración:"
  },
  "courseLoadError": {
    "title": "No se pudieron cargar los cursos",
    "body": "Fluencia necesita descargar la lista de cursos antes de empezar. Verifica tu conexión e inténtalo de nuevo.",
    "errorPrefix": "Error",
    "retry": "Intentar de nuevo",
    "retrying": "Intentando de nuevo…"
  },
  "featureGate": {
    "features": {
      "pronunciationAssessments": "Evaluaciones de pronunciación",
      "aiConversations": "Conversaciones con IA",
      "lessons": "Lecciones",
      "detailedFeedback": "Comentarios detallados",
      "audioLessons": "Lecciones de audio"
    },
    "upgradeToUnlock": "Mejora a Pro para desbloquear esta función",
    "unlockMoreFeatures": "Desbloquea más funciones",
    "unlockDescription": "Mejora a Fluencia Pro para acceso ilimitado a todas las funciones.",
    "trialActive": "Prueba activa",
    "upgradeToPro": "Mejorar a Pro",
    "viewSubscription": "Ver suscripción",
    "upgradeNow": "Mejorar ahora",
    "trialExpiresToday": "¡La prueba expira hoy!",
    "trialDaysLeft_one": "{{count}} día restante en tu prueba",
    "trialDaysLeft_other": "{{count}} días restantes en tu prueba",
    "featureRequiresPro": "Esta función requiere Fluencia Pro. Mejora tu plan para desbloquear acceso ilimitado."
  },
  "audioLessons": {
    "title": "Escuchar",
    "grammarGroupTitle": "Gramática para llevar",
    "emptyHint": "Aún no hay lecciones de audio",
    "loadErrorRetry": "Reintentar",
    "episodeCount_one": "{{count}} episodio",
    "episodeCount_other": "{{count}} episodios",
    "seriesProgress": "{{completed}} de {{total}} completados",
    "seriesCardLabel": "{{title}}, {{count}} episodios",
    "listenOnTheGo": "Escuchar sobre la marcha",
    "series": {
      "emptyHint": "Aún no hay episodios",
      "episodeLabel": "{{title}}",
      "resume": "Reanudar",
      "completed": "Completado",
      "premium": "Pro"
    },
    "player": {
      "play": "Reproducir",
      "pause": "Pausar",
      "skipBack": "Retroceder {{seconds}} segundos",
      "skipForward": "Avanzar {{seconds}} segundos",
      "seek": "Buscar",
      "loadError": "No pudimos cargar este episodio.",
      "retry": "Reintentar",
      "taughtIn": "Enseñado en",
      "transcript": "Transcripción",
      "renditionUnavailable": "Ese idioma no está disponible para este episodio."
    }
  },
  "native": {
    "language": "Español",
    "variant": "Latinoamérica",
    "variantHint": "tú/ustedes",
    "testPhrase": "El clima es muy agradable hoy"
  },
  "countryPicker": {
    "title": "Selecciona tu país",
    "suggested": "Sugerido"
  },
  "languageSettings": {
    "country": "País",
    "variant": "Variante del idioma",
    "variantHint": "Tu país tiene varias comunidades lingüísticas. Elige la variante más cercana a ti.",
    "lessonLanguage": "Idioma de las lecciones",
    "targetLocale": "Variante de aprendizaje",
    "targetLocaleHint": "Elige qué acento y vocabulario quieres aprender."
  },
  "onboarding": {
    "title": "Configura tu experiencia",
    "subtitle": "Personalizaremos tus lecciones según tu región.",
    "confirm": "Continuar"
  },
  "updates": {
    "availableTitle": "Actualización disponible",
    "availableMessage": "Se descargó una nueva versión. ¿Reiniciar para aplicar la actualización?",
    "later": "Después",
    "restart": "Reiniciar"
  },
  "messages": {
    "forceUpdate": {
      "title": "Actualización necesaria",
      "body": "Esta versión de Fluencia ya no es compatible. Actualiza para continuar.",
      "action": "Actualizar ahora"
    },
    "softUpdate": {
      "title": "Actualización disponible",
      "body": "Hay una nueva versión de Fluencia con mejoras y correcciones.",
      "action": "Actualizar",
      "dismiss": "Después"
    },
    "announcement": {
      "title": "Novedades",
      "body": "Descubre las últimas funciones y mejoras.",
      "action": "Más información"
    }
  },
  "errors": {
    "api": {
      "OFFLINE": "Sin conexión. Verifica tu conexión a internet.",
      "SERVER_UNREACHABLE": "No se puede conectar al servidor. Intenta más tarde.",
      "TIMEOUT": "La solicitud tardó demasiado. Intenta de nuevo.",
      "VALIDATION_FAILED": "Verifica los datos ingresados e intenta de nuevo.",
      "NOT_FOUND": "No se encontró el recurso solicitado.",
      "USER_NOT_FOUND": "Usuario no encontrado.",
      "RATE_LIMITED": "Demasiados intentos. Espera un momento.",
      "QUOTA_EXCEEDED": "Límite de uso alcanzado.",
      "UNAUTHORIZED": "Se requiere iniciar sesión.",
      "TOKEN_EXPIRED": "Tu sesión expiró. Inicia sesión de nuevo.",
      "FORBIDDEN": "Acceso denegado.",
      "AI_CONSENT_REQUIRED": "Acepta el uso compartido de datos de IA para usar esta función.",
      "ACCOUNT_DELETED": "Esta cuenta ha sido eliminada.",
      "INTERNAL_ERROR": "Algo salió mal.",
      "SERVICE_UNAVAILABLE": "Servicio temporalmente no disponible. Intenta más tarde.",
      "AI_SERVICE_ERROR": "Error del servicio de IA. Intenta de nuevo.",
      "AI_PROVIDER_ERROR": "Error del servicio de IA. Intenta de nuevo.",
      "AI_EMPTY_RESPONSE": "No se recibió respuesta. Intenta de nuevo.",
      "AI_STREAM_ERROR": "Respuesta interrumpida. Intenta de nuevo.",
      "DATABASE_ERROR": "Algo salió mal.",
      "UNKNOWN": "Algo salió mal.",
      "SESSION_BUSY": "Esta conversación se está usando en otro dispositivo. Espera un momento.",
      "ROLEPLAY_SLOTS_FULL": "Ya tienes {{cap}} simulaciones. Elimina una para crear un escenario nuevo.",
      "ROLEPLAY_SLOT_NOT_FOUND": "Esta simulación ya no existe.",
      "ROLEPLAY_SETUP_INVALID": "Hubo un problema con la configuración. Inténtalo de nuevo.",
      "ROLEPLAY_TEMPLATE_NOT_FOUND": "Esta plantilla ya no está disponible."
    },
    "auth": {
      "INVALID_CREDENTIALS": "Correo electrónico o contraseña incorrectos. Intenta de nuevo.",
      "USER_NOT_FOUND": "No se encontró una cuenta con este correo electrónico.",
      "EMAIL_NOT_CONFIRMED": "Verifica tu correo electrónico antes de iniciar sesión. Revisa tu bandeja de entrada para el enlace de confirmación.",
      "USER_ALREADY_EXISTS": "Ya existe una cuenta con este correo electrónico. Intenta iniciar sesión.",
      "WEAK_PASSWORD": "La contraseña es muy débil. Usa al menos 8 caracteres con una combinación de letras y números.",
      "RATE_LIMITED": "Demasiados intentos. Espera un momento e intenta de nuevo.",
      "SAME_PASSWORD": "La nueva contraseña debe ser diferente a tu contraseña actual.",
      "RESET_LINK_EXPIRED": "El enlace de restablecimiento expiró. Solicita uno nuevo.",
      "RECOVERY_CODE_INVALID": "El código no es válido o expiró. Solicita uno nuevo.",
      "SIGNUP_CODE_INVALID": "El código no es válido o expiró. Solicita uno nuevo.",
      "SESSION_EXPIRED": "Tu sesión expiró. Inicia sesión de nuevo.",
      "UNKNOWN": "Ocurrió un error de autenticación. Intenta de nuevo."
    },
    "generic": {}
  },
  "micTest": {
    "title": "Prueba de micrófono",
    "instructions": "Lee la frase a continuación en voz alta para verificar que tu micrófono funciona correctamente.",
    "sayThisPhrase": "Di esta frase:",
    "startTest": "Iniciar prueba",
    "recording": "Grabando...",
    "testAgain": "Probar de nuevo",
    "youSaid": "Escuchamos:",
    "resultWorking": "Tu micrófono funciona correctamente",
    "resultWorkingDetail": "El audio es claro y se reconoció la voz correctamente.",
    "resultQuality": "Podemos escucharte, pero la calidad de audio podría mejorar",
    "resultQualityTip1": "Ve a un lugar más silencioso",
    "resultQualityTip2": "Acerca el teléfono a tu boca",
    "resultQualityTip3": "Revisa si la funda del teléfono cubre el micrófono",
    "resultNotDetected": "No pudimos detectar tu voz",
    "resultNotDetectedTip1": "Asegúrate de que el micrófono no esté bloqueado",
    "resultNotDetectedTip2": "Intenta quitar la funda del teléfono",
    "resultNotDetectedTip3": "Cierra otras aplicaciones que puedan estar usando el micrófono",
    "resultNotDetectedTip4": "Reinicia la aplicación e intenta de nuevo",
    "tipsTitle": "Consejos",
    "errorConnection": "No se pudo conectar al servicio de voz. Verifica tu conexión a internet."
  },
  "vocabSets": {
    "title": "Conjuntos de palabras",
    "drillTitle": "Práctica",
    "loading": "Cargando…",
    "loadError": "No pudimos cargar los conjuntos.",
    "intro": "Grupos de palabras para practicar directamente. Escribe la palabra en inglés: solo cuenta si la produces tú.",
    "countLabel": "{{done}} de {{total}} dominadas",
    "inputPlaceholder": "Escribe la palabra en inglés",
    "check": "Comprobar",
    "reveal": "Mostrar la respuesta",
    "next": "Siguiente",
    "empty": "Este conjunto todavía no tiene palabras.",
    "markError": "No pudimos guardar tu respuesta. Inténtalo de nuevo.",
    "speak": "Decirlo en voz alta",
    "pronunciationScore": "Pronunciación: {{score}}/100",
    "notHeard": "No te escuchamos bien. Inténtalo otra vez."
  }
}
